import { Card } from '@/components/ui';

interface KPICardProps {
  label: string;
  value: string | number;
  hint?: string;
  /**
   * `warning` recolours the value when the number itself is the problem — a
   * queue backing up, retries accumulating. Kept as a named tone rather than a
   * className prop so every caller warns in the same colour.
   */
  tone?: 'default' | 'warning';
}

export function KPICard({
  label,
  value,
  hint,
  tone = 'default',
}: KPICardProps) {
  return (
    <Card className="p-4 flex flex-col gap-1">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span
        className={`text-2xl font-semibold ${
          tone === 'warning' ? 'text-warning' : 'text-foreground'
        }`}
      >
        {value}
      </span>
      {hint ? (
        <span className="text-xs text-muted-foreground">{hint}</span>
      ) : null}
    </Card>
  );
}
